import { render, staticRenderFns } from "./MoralPersonEdit.vue?vue&type=template&id=365aaff4&scoped=true"
import script from "./MoralPersonEdit.vue?vue&type=script&lang=js"
export * from "./MoralPersonEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365aaff4",
  null
  
)

export default component.exports